import React, { useState } from 'react';
import { 
  X, AlertTriangle, CheckCircle, Zap, Fuel, Gauge, MapPin, Clock
} from 'lucide-react';
import './advanced-map.css';
import { AppDrawer } from "../popup";

const AlertsPanel = ({ alerts, onClose, onDismiss }) => {
  const [filterType, setFilterType] = useState('all');

  const alertConfig = {
    overspeed: { icon: Gauge, color: '#ef4444', label: 'Over-speed' },
    geofence_exit: { icon: MapPin, color: '#f59e0b', label: 'Geofence Exit' },
    geofence_entry: { icon: MapPin, color: '#10b981', label: 'Geofence Entry' },
    fuel_drop: { icon: Fuel, color: '#ef4444', label: 'Fuel Drop' },
    ignition_on: { icon: Zap, color: '#10b981', label: 'Ignition ON' },
    ignition_off: { icon: Zap, color: '#64748b', label: 'Ignition OFF' },
    default: { icon: AlertTriangle, color: '#64748b', label: 'System Alert' }
  };

  const filtered = alerts.filter(a => filterType === 'all' || a.severity === filterType);
  
  return (
    <AppDrawer open onClose={onClose} title="System alerts" subtitle={`${filtered.length} active alerts`} width={440}>

        <div className="alerts-filters">
          {['all', 'critical', 'warning', 'info'].map(type => (
            <button 
              key={type} 
              className={`filter-tab ${filterType === type ? 'active' : ''}`}
              onClick={() => setFilterType(type)}
            >
              {type.charAt(0).toUpperCase() + type.slice(1)}
            </button>
          ))}
        </div>

        <div className="alerts-list">
          {filtered.length > 0 ? filtered.map(alert => {
            const conf = alertConfig[alert.type] || alertConfig.default;
            const Icon = conf.icon;
            return (
              <div key={alert.id} className={`alert-item ${alert.read ? 'read' : 'unread'}`}>
                <div className="alert-icon-wrapper" style={{background: `${conf.color}20`, color: conf.color}}>
                  <Icon size={20} />
                </div>
                <div className="alert-content">
                  <div className="alert-header-row">
                    <span className="alert-label">{conf.label}</span>
                    <span className={`severity-badge ${alert.severity}`}>{alert.severity}</span>
                  </div>
                  <p className="alert-message">{alert.message}</p>
                  <div className="alert-meta">
                    <span><MapPin size={10}/> {alert.deviceName}</span>
                    <span><Clock size={10}/> {new Date(alert.timestamp).toLocaleTimeString()}</span>
                  </div>
                </div>
                <button className="alert-dismiss-btn" onClick={() => onDismiss(alert.id)}><X size={14}/></button>
              </div>
            );
          }) : (
            <div className="alerts-empty">
              <CheckCircle size={48} color="#cbd5e1"/>
              <p>No alerts found</p>
            </div>
          )}
        </div>

        {filtered.length > 0 && (
          <div className="alerts-footer">
            <button className="act-btn outline full-width" onClick={() => filtered.forEach(a => onDismiss(a.id))}>
              Dismiss All
            </button>
          </div>
        )}
    </AppDrawer>
  );
};

export default AlertsPanel;
